var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('app-history',{attrs:{"title":"ارسال درخواست"},on:{"clicked":function($event){return _vm.$router.push('/talabbos-request')}}}),_c('app-history',{on:{"clicked":function($event){return _vm.$router.push('/talabbos-history')}}}),_c('app-history',{attrs:{"title":"تایید تلبس طلاب"},on:{"clicked":_vm.checkConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }